import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { routeEvent } from 'garaje/utils/decorators/route';

import type ResourcesResourceTypeImportController from './controller';

export interface ResourcesResourceTypeImportRouteModel {
  resourceTypeId: string;
}

export default class ResourcesResourceTypeImportRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (this.abilities.cannot('import resources')) {
      this.router.transitionTo('unauthorized');
    }
  }

  model(): ResourcesResourceTypeImportRouteModel {
    const { resource_type_id } = this.paramsFor('resources.resource-type') as { resource_type_id: string };
    return { resourceTypeId: resource_type_id };
  }

  @routeEvent
  routeWillChange(): void {
    // eslint-disable-next-line ember/no-controller-access-in-routes
    const controller = this.controllerFor('resources.resource-type.import') as ResourcesResourceTypeImportController;
    controller.clearAll();
  }
}
